<div class="additional-parameters-header" (click)="toggleAdditionalParams()">
  <nb-icon class="warning-icon" icon="warning" pack="icomoon"></nb-icon>
  <h1>{{ 'view_translations.additional_link_parameters' | translate}}</h1>
  <div
    class="tooltip-container tool-tip"
    ngbTooltip="{{ 'view_translations.additional_link_params_info' | translate }}"
    container="body"
    placement="top"
    tooltipClass="my-configurations-tooltip">
    <nb-icon icon="info" pack="icomoon"></nb-icon>
  </div>
  <div class="arrow-container" [ngClass]="{ 'menuOpened': isAdditionalParameters }">
    <nb-icon icon="chevron-right" pack="icomoon"></nb-icon>
  </div>
</div>
<div class="additional-parameters-container" *ngIf="isAdditionalParameters">
  <div class="ml-sub-container" *ngFor="let sub of [1, 2, 3, 4, 5]; index as i">
    <label for="{{'mlSub' + sub}}">ML_SUB{{sub}}</label>
    <input type="text" placeholder="{{ 'view_translations.type_text' | translate }}" (keyup)="getText($event, i)" />
  </div>
</div>
